import React, { useState } from 'react';
import { LprConfigList } from './ConfigList_2';
import { useFetch } from '../../../hooks/useFetch2';
import { api } from './api';
import { useAuthStore } from '../../../store/useAuthStore3';

export const LprConfigPage = () => {
    const { data: categories, } = useFetch(api.getCategories, []);
    const { data: params, setData: setParams } = useFetch(api.getParams, []);
    const { customerId } = useAuthStore();

    const handleParamSave = async (paramId: string, newValue: string) => {
        console.log(`Сохраняем параметр ${paramId}:`, newValue);

        const res = await api.setParam(customerId || -1, paramId, newValue );
        if (res) {
            setParams((prev) =>
                prev.map((p) => (p.param_id === paramId ? { ...p, value: newValue } : p))
            );
        } else {
            alert('Cannot save parameter');
        }
    };

  return <LprConfigList categories={categories} params={params} onParamSave={handleParamSave} />;
};